import React, { useEffect, useState } from "react";
import useCoreAgoraCheck from "../../../../general/customHooks/coreAgoraCheck";
import { ExclamationTriangle } from "react-bootstrap-icons";
import {
  LogoFullColor,
  LogoFullWhite,
} from "../../../../general/assets/assets";

export default function CameraAndAudioCheckingView(props) {
  const { setIsHold } = props;
  const { selfTracks, isSelfTracksReady, error } = useCoreAgoraCheck();

  useEffect(() => {
    if (isSelfTracksReady == true && error == null) {
      setIsHold();
    }
    if (error != null) {
      console.log("error agora", error);
    }
    console.log("error agora 2", error, isSelfTracksReady);
  }, [isSelfTracksReady, error]);
  return (
    <div className="flex items-center justify-center h-screen bg-black">
      <div className="w-full aspect-video max-w-5xl border border-gray-600 relative flex flex-col items-center justify-center gap-2 bg-secondary-900 rounded-md">
        <div className="absolute top-4 left-4">
          <LogoFullColor className="h-10" />
        </div>
        {error != null ? (
          <>
            <ExclamationTriangle size={32} className="text-white" />
            <label className="font-medium text-lg text-white">{error}</label>
          </>
        ) : (
          <>
            <label className="font-medium text-lg text-white">
              Compatibility check...
            </label>
            <label className="font-medium text-base text-white">
              Please allow cameras and audio use then reload the page.
            </label>
          </>
        )}
      </div>
    </div>
  );
}
